import {
  GetAssetAvatarListResponse,
  GetAssetFileUrlListRequest,
  GetAssetFileUrlListResponse,
  GetAssetMotionListResponse,
} from '~/types/assetStoreApi';
import { fetcher } from './config/fetcher';
import http from './config/http';

// 아래 api 3개는 모두 안쓰는 api
export const getAssetAvatarList = async () => {
  return fetcher(() =>
    http.get<GetAssetAvatarListResponse>('/character/assetAvatarList'),
  );
};

export const getAssetMotionList = async () => {
  return fetcher(() =>
    http.get<GetAssetMotionListResponse>('/character/assetMotionList'),
  );
};

export const getAssetFileUrlList = async (
  request: GetAssetFileUrlListRequest,
) => {
  return fetcher(() =>
    http.post<GetAssetFileUrlListResponse>('/character/assetFileUrl', request),
  );
};
